import { render, staticRenderFns } from "./DashboardStatsBadge.vue?vue&type=template&id=bb7fe732&scoped=true"
import script from "./DashboardStatsBadge.vue?vue&type=script&lang=js"
export * from "./DashboardStatsBadge.vue?vue&type=script&lang=js"
import style0 from "./DashboardStatsBadge.vue?vue&type=style&index=0&id=bb7fe732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7fe732",
  null
  
)

export default component.exports